module.exports = __webpack_public_path__ + "img/실피드.d581c940.png";